import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Reports/TrialBalance/TrialBalance.css";
import * as XLSX from "xlsx";
import "jspdf-autotable";
import { useNavigate, useLocation } from "react-router-dom";
import PdfPreview from "../../../Common/PDFPreview";
import { jsPDF } from "jspdf";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import { RingLoader } from 'react-spinners';
import { Typography } from '@mui/material';
import { FormaDateBalanceSheet } from "../../../Common/FormatFunctions/FormatDate"
import PrintButton from '../../../Common/Buttons/PrintPDF';

const apikey = process.env.REACT_APP_API;

const BalancesheetReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // const { fromDate, toDate } = location.state || { fromDate: "", toDate: "" };
  const searchParams = new URLSearchParams(location.search);
  const fromDate = searchParams.get('fromDate');
  const toDate = searchParams.get('toDate');

  const companyCode = sessionStorage.getItem("Company_Code");
  const Year_Code = sessionStorage.getItem("Year_Code");
  const Company_Name = sessionStorage.getItem("Company_Name")
  const Company_GSTNO = sessionStorage.getItem('Company_GSTNO')
  const CompanyNameUpdatedDate = sessionStorage.getItem("CompanyNameUpdatedDate")
  const newCompanyName = sessionStorage.getItem("newCompanyName")

  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [emailId, setEmailId] = useState("");
  const [pdfPreview, setPdfPreview] = useState([]);
  const [groupedReportData, setGroupedReportData] = useState({});
  const [groupedReportDataRightside, setGroupedReportDataRightside] = useState(
    {}
  );

  const API_URL = `${apikey}/Balancesheet_Report`;

  const docDate = new Date(fromDate);
  const cnameUpdatedDate = new Date(CompanyNameUpdatedDate);

  const displayCompanyName =
    docDate < cnameUpdatedDate
      ? newCompanyName
      : Company_Name;

  useEffect(() => {
    const fetchReportData = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await axios.get(API_URL, {
          params: {
            to_date: toDate,
            Company_Code: companyCode,
            Year_Code: Year_Code,
          },
        });
        setReportData(response.data);
      } catch (error) {
        console.error("Error fetching report:", error);
        setError("Error fetching report");
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [API_URL]);

  const handleExportToExcel = () => {
    const wb = XLSX.utils.book_new();
    const titleRow = [`${displayCompanyName} - Balance Sheet Report`];
    const dateRow = [`As on ${toDate}`];
    const headers = [["Liabilities (Group Code & Name)", "", "", "Amount", "Assets (Group Code & Name)", "", "", "Amount"]];

    const ws_data = [titleRow, dateRow, [], ...headers];

    const leftEntries = Object.entries(groupedReportData);
    const rightEntries = Object.entries(groupedReportDataRightside);
    const maxLen = Math.max(leftEntries.length, rightEntries.length);

    for (let i = 0; i < maxLen; i++) {
      const leftGroup = leftEntries[i] ? leftEntries[i][1] : undefined;
      const rightGroup = rightEntries[i] ? rightEntries[i][1] : undefined;

      ws_data.push([
        leftGroup ? leftEntries[i][0] : "", // **Left Group Code & Name**
        "",
        "",
        leftGroup ? Math.abs(parseFloat(leftGroup.totalBalance).toFixed(2)) : "",
        rightGroup ? rightEntries[i][0] : "", // **Right Group Code & Name**
        "",
        "",
        rightGroup ? Math.abs(parseFloat(rightGroup.totalBalance).toFixed(2)) : ""
      ]);

      const maxItems = Math.max(leftGroup ? leftGroup.items.length : 0, rightGroup ? rightGroup.items.length : 0);
      for (let j = 0; j < maxItems; j++) {
        const leftItem = leftGroup && leftGroup.items[j] ? leftGroup.items[j] : undefined;
        const rightItem = rightGroup && rightGroup.items[j] ? rightGroup.items[j] : undefined;

        ws_data.push([
          leftItem ? `  ${leftItem.Ac_Code} - ${leftItem.Ac_Name_E.toUpperCase()}` : "",
          "",
          leftItem
            ? (leftItem.BalanceDrCr === "D"
              ? -Math.abs(Number(parseFloat(leftItem.Balance).toFixed(2)))
              : Math.abs(Number(parseFloat(leftItem.Balance).toFixed(2))))
            : ""
          ,
          "",
          rightItem ? `  ${rightItem.Ac_Code} - ${rightItem.Ac_Name_E.toUpperCase()}` : "",
          "",
          rightItem
            ? (rightItem.BalanceDrCr === "C"
              ? -Math.abs(Number(parseFloat(rightItem.Balance).toFixed(2)))
              : Math.abs(Number(parseFloat(rightItem.Balance).toFixed(2))))
            : ""

        ]);
      }
    }

    ws_data.push(["", "", "", "", "", "", ""]);

    ws_data.push([
      "Total Liabilities", "", "", Math.abs(parseFloat(totalLeftSide).toFixed(2)),
      "Total Assets", "", "", Math.abs(parseFloat(totalRightSide).toFixed(2))
    ]);

    ws_data.push([
      "Net Profit", "", "", Math.abs(parseFloat(netProfit).toFixed(2)),
      "", "", "", ""
    ]);

    const ws = XLSX.utils.aoa_to_sheet(ws_data);
    ws['!cols'] = [
      { wch: 50 }, { wch: 5 }, { wch: 5 }, { wch: 20 },
      { wch: 50 }, { wch: 5 }, { wch: 5 }, { wch: 20 }
    ];

    XLSX.utils.book_append_sheet(wb, ws, "BalanceSheet Reports");
    XLSX.writeFile(wb, "BalanceSheetReport.xlsx");
  };

  // const handleRowClick = (acCode, acname) => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     const url = `/getAllledger-report?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&acCode=${encodeURIComponent(acCode)}`;
  //     window.open(url, '_blank', 'toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600');
  //     setLoading(false);
  //   }, 500);
  // };

  const handleRowClick = (acCode, acname) => {
    setLoading(true);
    setTimeout(() => {
      const url = `/ledger-report?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&acCode=${encodeURIComponent(acCode)}&acname=${encodeURIComponent(acname)}`;
      window.open(url, '_blank', 'toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600');
      setLoading(false);
    }, 500);
  };

  const handleGroupClick = (groupKey) => {
    if (!groupKey) return;

    const parts = groupKey.split(" - ");
    const groupCode = parseInt(parts[0], 10);

    setLoading(true);

    setTimeout(() => {
      const url = `/TrialBalance-reports?fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}&groupType=${encodeURIComponent(groupCode)}`;
      window.open(url, '_blank', 'toolbar=yes,location=yes,status=yes,menubar=yes,scrollbars=yes,resizable=yes,width=800,height=600');
      setLoading(false);
    }, 500);
  };

  useEffect(() => {
    if (reportData.length > 0) {
      const { groupedDataleft, groupedReportDataRightside } =
        convertData(reportData);
      setGroupedReportData(groupedDataleft);
      setGroupedReportDataRightside(groupedReportDataRightside);
    }
  }, [reportData]);

  const convertData = (data) => {
    const groupedDataleft = {};
    const groupedReportDataRightside = {};

    let groupTotals = {};

    data.forEach((item) => {
      const balance = parseFloat(item.Balance) || 0;
      const groupKey = `${item.Group_Code} - ${item.groupname}`;

      if (!groupTotals[groupKey]) {
        groupTotals[groupKey] = 0;
      }
      groupTotals[groupKey] += balance;
    });

    data.forEach((item) => {
      const balance = parseFloat(item.Balance) || 0;
      const groupKey = `${item.Group_Code} - ${item.groupname}`;
      const totalBalance = groupTotals[groupKey];

      if (totalBalance === 0) return;

      let target =
        totalBalance < 0 ? groupedDataleft : groupedReportDataRightside;

      if (!target[groupKey]) {
        target[groupKey] = {
          groupname: item.groupname,
          items: [],
          totalBalance: totalBalance,
          showOnlyTotal: false,
        };
      }

      if (item.summary === "Y") {
        target[groupKey].showOnlyTotal = true;
      } else {
        target[groupKey].items.push({
          Ac_Code: item.AC_CODE,
          Ac_Name_E: item.Ac_Name_E,
          Balance: balance.toFixed(2),
          BalanceDrCr: item.BalanceDrCr
        });
      }
    });

    return { groupedDataleft, groupedReportDataRightside };
  };

  const totalDebit = Object.values(groupedReportDataRightside)
    .reduce((acc, { totalBalance }) => acc + Math.abs(totalBalance), 0)
    .toFixed(2);

  const totalFromGroupedData = Object.values(groupedReportData)
    .reduce((acc, { totalBalance }) => acc + Math.abs(totalBalance), 0);

  const totalFromRightsideData = Object.values(groupedReportDataRightside)
    .reduce((acc, { totalBalance }) => acc + Math.abs(totalBalance), 0);

  const difference = totalFromRightsideData - totalFromGroupedData;

  const totalCredit = totalFromGroupedData + Math.abs(difference);

  const formattedTotalCredit = totalCredit.toFixed(2);

  const totalCreditRightSide = Object.values(groupedReportDataRightside)
    .reduce(
      (acc, { totalBalance }) => acc + Math.abs(totalBalance),
      0
    )
    .toFixed(2)

  const netProfit = Math.abs(
    Object.values(groupedReportDataRightside).reduce(
      (acc, { totalBalance }) => acc + Math.abs(totalBalance),
      0
    ) -
    Object.values(groupedReportData).reduce(
      (acc, { totalBalance }) => acc + Math.abs(totalBalance),
      0
    )
  ).toFixed(2)

  const totalRightSide = Object.values(groupedReportDataRightside)
    .reduce(
      (acc, { totalBalance }) => acc + Math.abs(totalBalance),
      0
    )
    .toFixed(2)

  const totalLeftSide = Object.values(groupedReportData)
    .reduce(
      (acc, { totalBalance }) => acc + Math.abs(totalBalance),
      0
    )
    .toFixed(2)


  const renderPdf = (outputType = "blob") => {
    const doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });

    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 40;
    const centerX = pageWidth / 2;

    const fontSize = 9;
    const lineHeight = 14;
    const labelWidth = 140;

    const leftTextX = margin + 10;
    const leftAmtX = centerX - 40;

    const rightTextX = centerX + 30;
    const rightAmtX = pageWidth - margin;

    let leftY = 0;
    let rightY = 0;

    const drawDivider = (endY = Math.max(leftY, rightY)) => {
      const startY = 76;
      doc.setLineWidth(0.5);
      doc.line(centerX, startY, centerX, endY + 3);
    };

    const drawHeaders = () => {
      let y = 36;
      doc.setFontSize(10);
      doc.setFont("Arial", "bold");
      doc.text(displayCompanyName.trim(), centerX, y, { align: "center" });

      y += 12;
      doc.setFontSize(8);
      doc.setFont("Arial", "normal");
      const gstnText = `GSTN : ${Company_GSTNO}`;
      doc.text(gstnText, centerX, y, { align: "center" });

      const textWidth = doc.getTextWidth(gstnText);
      const underlineStartX = centerX - textWidth / 2;
      const underlineY = y + 1.5;

      doc.setLineWidth(0.3);
      doc.line(underlineStartX, underlineY, underlineStartX + textWidth, underlineY);

      y += 12;
      doc.setFont("Arial", "bold");
      doc.text("Balance Sheet", centerX, y, { align: "center" });

      y += 10;
      doc.setFontSize(8);
      doc.setFont("Arial", "normal");
      doc.text(
        `From ${fromDate.split("-").reverse().join("-")} to ${toDate
          .split("-")
          .reverse()
          .join("-")}`,
        centerX,
        y,
        { align: "center" }
      );

      y += 14;
      doc.setLineWidth(0.5);
      doc.line(margin - 10, y - 8, pageWidth - margin + 20, y - 8);

      doc.setFontSize(fontSize + 1);
      doc.setFont("Arial", "bold");
      doc.text("Liabilities", margin, y);
      doc.text("Amount", leftAmtX, y, { align: "right" });
      doc.text("Assets", centerX + 20, y);
      doc.text("Amount", rightAmtX, y, { align: "right" });

      doc.line(margin - 10, y + 5, pageWidth - margin + 20, y + 5);

      leftY = rightY = y + 10;
      drawDivider();
    };

    const checkPageBreak = () => {
      if (leftY > pageHeight - 60 || rightY > pageHeight - 60) {
        doc.addPage();
        leftY = rightY = 60;
        drawDivider();
      }
    };

    drawHeaders();
    doc.setFontSize(fontSize);

    const leftEntries = Object.entries(groupedReportData);
    const rightEntries = Object.entries(groupedReportDataRightside);
    const maxLen = Math.max(leftEntries.length, rightEntries.length);

    for (let i = 0; i < maxLen; i++) {
      const left = leftEntries[i];
      const right = rightEntries[i];

      const leftHasItems = left && left[1].items.length > 0;
      const rightHasItems = right && right[1].items.length > 0;
      if (!leftHasItems && !rightHasItems) continue;

      // LEFT SIDE
      if (leftHasItems) {
        const [, group] = left;
        doc.setFont("Arial", "bold");
        doc.text(group.groupname.trim().toUpperCase(), margin - 10, leftY + 10);
        doc.text(
          formatReadableAmount(Math.abs(group.totalBalance)),
          leftAmtX + 35,
          leftY + 10,
          { align: "right" }
        );
        leftY += lineHeight;

        doc.setFont("Arial", "italic");

        let lastItemBottomY = leftY;
        for (let j = 0; j < group.items.length; j++) {
          checkPageBreak();
          const item = group.items[j];
          const lines = doc.splitTextToSize(item.Ac_Name_E.trim().toUpperCase(), labelWidth);
          doc.text(lines, leftTextX - 10, leftY + 10);
          doc.text(
            item.BalanceDrCr === "D"
              ? `-${formatReadableAmount(Math.abs(item.Balance))}`
              : formatReadableAmount(Math.abs(item.Balance)),
            leftAmtX - 5,
            leftY + 10,
            { align: "right" }
          );

          if (j === group.items.length - 1) {
            lastItemBottomY = leftY + (lineHeight * (lines.length));
          }

          leftY += lineHeight * lines.length;
        }

        doc.setLineWidth(0.5);
        doc.line(leftAmtX - 50, lastItemBottomY, leftAmtX, lastItemBottomY);
        leftY += 6;
      }

      // RIGHT SIDE
      if (rightHasItems) {
        const [, group] = right;
        doc.setFont("Arial", "bold");
        doc.text(group.groupname.trim().toUpperCase(), centerX + 2, rightY + 10);
        doc.text(
          formatReadableAmount(Math.abs(group.totalBalance)),
          rightAmtX + 25,
          rightY + 10,
          { align: "right" }
        );
        rightY += lineHeight;

        doc.setFont("Arial", "italic");

        let lastItemBottomY = rightY;
        for (let j = 0; j < group.items.length; j++) {
          checkPageBreak();
          const item = group.items[j];
          const lines = doc.splitTextToSize(item.Ac_Name_E.trim().toUpperCase(), labelWidth);
          doc.text(lines, rightTextX - 25, rightY + 10);
          doc.text(item.BalanceDrCr === "C"
            ? `-${formatReadableAmount(Math.abs(item.Balance))}`
            : formatReadableAmount(Math.abs(item.Balance)), rightAmtX - 20, rightY + 10, {
            align: "right",
          });

          if (j === group.items.length - 1) {
            lastItemBottomY = rightY + (lineHeight * (lines.length));
          }

          rightY += lineHeight * lines.length;
        }

        doc.setLineWidth(0.5);
        doc.line(rightAmtX - 50, lastItemBottomY, rightAmtX, lastItemBottomY);
        rightY += 6;
      }

      drawDivider();
    }

    const finalY = Math.max(leftY, rightY) + 10;
    doc.setFont("Arial", "bold");
    doc.setLineWidth(0.75);
    doc.line(margin, finalY - 10, pageWidth - margin, finalY - 10);

    doc.text("Total Liabilities", margin, finalY);
    doc.text(formatReadableAmount(totalLeftSide), leftAmtX + 38, finalY, { align: "right" });

    doc.line(margin, finalY + 4, pageWidth - margin, finalY + 4);

    doc.text("Total Assets", centerX, finalY + lineHeight);
    doc.text(formatReadableAmount(totalRightSide), rightAmtX + 32, finalY + lineHeight, {
      align: "right",
    });

    doc.line(margin, finalY + lineHeight + 4, pageWidth - margin, finalY + lineHeight + 4);

    doc.text("Net Profit", margin, finalY + lineHeight);
    doc.text(formatReadableAmount(netProfit), leftAmtX + 38, finalY + lineHeight, {
      align: "right",
    });

    doc.text("Total Credit", margin, finalY + lineHeight * 2);
    doc.text(formatReadableAmount(formattedTotalCredit), leftAmtX + 38, finalY + lineHeight * 2, {
      align: "right",
    });

    doc.line(margin, finalY + lineHeight * 2 + 6, pageWidth - margin, finalY + lineHeight * 2 + 6);

    drawDivider(finalY + lineHeight * 2 + 6);

    if (outputType === "blob") {
      const pdfBlob = doc.output("blob");
      const url = URL.createObjectURL(pdfBlob);
      setPdfPreview(url);
    } else if (outputType === "print") {
      const dataUri = doc.output("datauristring");
      const printWindow = window.open();
      if (printWindow) {
        printWindow.document.write(`<iframe width='100%' height='100%' src='${dataUri}' frameborder='0'></iframe>`);
        printWindow.document.close();
      }
    }
  };

  const generatePdf = () => renderPdf("blob");
  const handlePrint = () => renderPdf("print");

  return (
    <div style={{ marginTop: "-90px" }}>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "24px", fontWeight: "bold" }}>{displayCompanyName}</Typography>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", textDecoration: 'underline', fontWeight: "550" }}>GSTN : {Company_GSTNO}</Typography>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "20px", fontWeight: "bold" }}>Balance Sheet</Typography>
      <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px" }}>{FormaDateBalanceSheet(fromDate)} to {FormaDateBalanceSheet(toDate)}</Typography>

      <div className="d-flex justify-content-end" style={{ marginTop: "-60px" }}>
        <PrintButton disabledFeild={""} fetchData={handlePrint} />
        <button className="btn btn-success" onClick={handleExportToExcel}>
          Export to Excel
        </button>
        <button onClick={generatePdf} className="btn btn-secondary">
          PDF
        </button>
      </div>

      <div className="table-responsive">
        <table
          className="table table-striped table-bordered mt-4"
          id="reportTable"
          style={{ marginBottom: "50px", backgroundColor: "#D0E9C6", }}
        >
          <thead className="table-light">
            <tr>
              <th colSpan={2} style={{ textAlign: "left", backgroundColor: "#D0E9C6" }}>
                Liabilities
              </th>
              <th colSpan={2} style={{ textAlign: "right", backgroundColor: "#D0E9C6" }}>
                Amount
              </th>
              <th colSpan={2} style={{ textAlign: "left", backgroundColor: "#D0E9C6" }}>
                Assets
              </th>
              <th colSpan={2} style={{ textAlign: "right", backgroundColor: "#D0E9C6" }}>
                Amount
              </th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td
                align="left"
                colSpan={4}
                style={{ verticalAlign: "top", width: "50%", backgroundColor: "#D0E9C6", }}
              >
                <table style={{ width: "100%", backgroundColor: "#D0E9C6", }}>
                  {Object.entries(groupedReportData).map(
                    ([key, { items, totalBalance, showOnlyTotal }]) => (
                      <React.Fragment key={key}>
                        <tr className="table-primary" onClick={() => handleGroupClick(key)}>
                          <td
                            colSpan={2}
                            style={{ color: "black", fontWeight: "bold", fontFamily: "Arial" }}
                          >
                            {key.toUpperCase()}
                          </td>
                          <td
                            align="right"
                            style={{ color: "black", fontWeight: "bold", fontFamily: "Arial" }}
                          >
                            {formatReadableAmount(Math.abs(totalBalance.toFixed(2)))}
                          </td>
                        </tr>
                        {!showOnlyTotal &&
                          items.map((item, index) => {
                            const isLast = index === items.length - 1;
                            return (
                              <tr key={item.Ac_Code}>
                                <td onClick={() => handleRowClick(item.Ac_Code, item.Ac_Name_E)} style={{ cursor: "pointer", fontStyle: "italic" }}>{item.Ac_Code}</td>
                                <td style={{ cursor: "pointer", fontStyle: "italic" }}>{item.Ac_Name_E}</td>
                                <td
                                  align="right"
                                  style={{
                                    paddingRight: "80px",
                                    textAlign: "right",
                                  }}
                                >
                                  <span
                                    style={{
                                      display: "inline-block",
                                      fontStyle: "italic",
                                      fontWeight: 450,
                                      marginRight: 120,
                                      borderBottom: isLast ? "2px solid black" : "none",
                                      paddingBottom: "2px",
                                      marginTop: "2px",
                                    }}
                                  >
                                    {item.BalanceDrCr === 'D'
                                      ? `-${formatReadableAmount(Math.abs(item.Balance))}`
                                      : formatReadableAmount(Math.abs(item.Balance))}

                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                      </React.Fragment>
                    )
                  )}
                </table>
              </td>
              <td
                align="center"
                colSpan={4}
                style={{ verticalAlign: "top", width: "50%", backgroundColor: "#D0E9C6", }}
              >
                <table style={{ width: "100%", backgroundColor: "#D0E9C6" }}>
                  {Object.entries(groupedReportDataRightside).map(
                    ([key, { items, totalBalance, showOnlyTotal }]) => (
                      <React.Fragment key={key}>
                        <tr className="table-primary" onClick={() => handleGroupClick(key)}>
                          <td
                            colSpan={2}
                            style={{ color: "black", fontWeight: "bold", fontFamily: "Arial" }}
                          >
                            {key.toUpperCase()}
                          </td>
                          <td
                            align="right"
                            style={{ color: "black", fontWeight: "bold", fontFamily: "Arial" }}
                          >
                            {formatReadableAmount(Math.abs(totalBalance.toFixed(2)))}
                          </td>
                        </tr>
                        {!showOnlyTotal &&
                          items.map((item, index) => {
                            const isLast = index === items.length - 1;
                            return (
                              <tr key={item.Ac_Code}>
                                <td
                                  onClick={() => handleRowClick(item.Ac_Code, item.Ac_Name_E)}
                                  style={{ cursor: "pointer", fontStyle: "italic" }}
                                >
                                  {item.Ac_Code}
                                </td>
                                <td style={{ cursor: "pointer", fontStyle: "italic" }}>
                                  {item.Ac_Name_E}
                                </td>
                                <td
                                  align="right"
                                  style={{
                                    paddingRight: "160px",
                                    paddingLeft: "20px",
                                  }}
                                >
                                  <span
                                    style={{
                                      display: "inline-block",
                                      fontStyle: "italic",
                                      fontWeight: 450,
                                      marginRight: 30,
                                      borderBottom: isLast ? "2px solid black" : "none",
                                      paddingBottom: "2px",
                                      marginTop: "2px",
                                    }}
                                  >
                                    {item.BalanceDrCr === 'C'
                                      ? `-${formatReadableAmount(Math.abs(item.Balance))}`
                                      : formatReadableAmount(Math.abs(item.Balance))}

                                  </span>
                                </td>
                              </tr>
                            );
                          })}
                      </React.Fragment>
                    )
                  )}
                </table>
              </td>
            </tr>
            <tr >
              <td
                colSpan={3}
                className="fw-bold text-end"
                style={{ color: "black", backgroundColor: "#D0E9C6" }}
              >
                Total
              </td>
              <td align="right" className="fw-bold" style={{ backgroundColor: "#D0E9C6", }}>
                {formatReadableAmount(totalLeftSide)}
              </td>

              <td
                colSpan={3}
                className="fw-bold text-end"
                style={{ backgroundColor: "#D0E9C6" }}
              >
                Total
              </td>
              <td align="right" className="fw-bold" style={{ backgroundColor: "#D0E9C6", }}>
                {formatReadableAmount(totalRightSide)}
              </td>
            </tr>

            <tr>
              <td
                colSpan={3}
                className="fw-bold text-end"
                style={{ backgroundColor: "#D0E9C6", }}
              >
                Net Profit
              </td>
              <td align="right" className="fw-bold" style={{ backgroundColor: "#D0E9C6", }}>
                {formatReadableAmount(netProfit)}
              </td>

              <td
                colSpan={3}
                className="fw-bold text-end"
                style={{ backgroundColor: "#D0E9C6", }}
              >
              </td>
              <td align="right" className="fw-bold" style={{ backgroundColor: "#D0E9C6", }}>
                {/* {formatReadableAmount(totalCreditRightSide)} */}
              </td>
            </tr>

            <tr>
              <td
                colSpan={3}
                className="fw-bold text-end"
                style={{ backgroundColor: "#D0E9C6", }}
              >
                Total Credit
              </td>
              <td align="right" className="fw-bold" style={{ backgroundColor: "#D0E9C6", }}>
                {formatReadableAmount(formattedTotalCredit)}
              </td>

              <td
                colSpan={3}
                className="fw-bold text-end"
                style={{ backgroundColor: "#D0E9C6", }}
              >
                Total Debit
              </td>
              <td align="right" className="fw-bold" style={{ backgroundColor: "#D0E9C6", }}>
                {formatReadableAmount(totalDebit)}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="centered-container">
          {pdfPreview && pdfPreview.length > 0 && (
            <PdfPreview
              pdfData={pdfPreview}
              apiData={reportData}
              label={"BalanceSheet"}
            />
          )}
        </div>
      </div>
      {loading && (
        <div style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 9999
        }}>
          <RingLoader size={80} />
        </div>
      )}
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default BalancesheetReport;
